import { render } from "./productCard.vue?vue&type=template&id=e1801b44&scoped=true"
const script = {}

import "./productCard.vue?vue&type=style&index=0&id=e1801b44&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1801b44"]])

export default __exports__